import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const DropdownContainer = ({ children }: Props) => (
  <div
    className="z-50 absolute right-0 top-[calc(100%+8px)] rounded-[32px] border border-blue-100 bg-surface
  shadow-[0px_2px_10px_0px_rgba(42,60,68,0.05)] w-[262px] h-auto flex flex-col items-start p-[16px] gap-2 "
  >
    {children}
  </div>
);
